/**
 * Fuel depletion and the fuel-out -> dying transition.
 *
 * Fuel only depletes during 'playing'. When it hits zero it's a death event;
 * the lives accounting happens in the dying/respawn logic added in Phase 5.
 */

import type { GameState } from './types.ts';
import { isSpeedBoostActive } from './stage.ts';

export function depleteFuel(state: GameState, amount: number): GameState {
  if (state.phase !== 'playing') return state;
  const next = Math.max(0, state.fuel - amount);
  if (next === 0 && state.fuel > 0) {
    return {
      ...state,
      fuel: 0,
      phase: 'dying',
      deathCause: 'fuel',
      respawnAt: state.tick + state.config.dyingDuration,
      events: [...state.events, { kind: 'player_die' }],
    };
  }
  return { ...state, fuel: next };
}

export function applyFuelTick(state: GameState): GameState {
  const multiplier = isSpeedBoostActive(state) ? state.config.speedBoostFuelMultiplier : 1;
  return depleteFuel(state, state.config.fuelPerTick * multiplier);
}
